// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { apiProxy, apiUrl } from './index';
import { IPageParams, IPageResult, adaptPageParams, adaptPageResult } from './utils';

export async function fetchPatrolBrief(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.patrolBrief}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchFaceRetrievals(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.faceRetrievals}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchPatrolPoints(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.patrolPoints}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function addPatrolPoint(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.patrolPoint()}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function deletePatrolPoint(id: string | number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.patrolPoint(id)}`, {
    method: 'DELETE',
  });
}

export async function updatePatrolPoint({
  id,
  ...data
}: {
  id: string | number;
  [key: string]: any;
}) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.patrolPoint(id)}`, {
    method: 'PUT',
    data,
  });
}

export async function activatePatrolPoints(data?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.patrolPointActivate}`, {
    method: 'PUT',
    data,
  });
}

export async function deletePatrolPoints(ids: (string | number)[] = []) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.patrolPointDelete}`, {
    method: 'DELETE',
    data: ids,
  });
}

export async function fetchPatrolTasks(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.patrolTasks}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function addPatrolTask(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.patrolTask()}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function deletePatrolTask(id: string | number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.patrolTask(id)}`, {
    method: 'DELETE',
  });
}

export async function updatePatrolTask({
  id,
  ...data
}: {
  id: string | number;
  [key: string]: any;
}) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.patrolTask(id)}`, {
    method: 'PUT',
    data,
  });
}

export async function fetchPatrolRecords(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.patrolRecords}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function updatePatrolRemark({
  id,
  ...data
}: {
  id: string | number;
  [key: string]: any;
}) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.patrolRemark(id)}`, {
    method: 'PUT',
    data,
  });
}
